// <faq-tabs>: a question rail that shows one answer at a time (product page "good to know" and the FAQ page).
if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const n = this.tabs.length;
          const next = { ArrowDown: i + 1, ArrowRight: i + 1, ArrowUp: i - 1, ArrowLeft: i - 1, Home: 0, End: n - 1 }[e.key];
          if (next === undefined) return;
          e.preventDefault();
          this.select((next + n) % n, true);
        });
      });
    }

    select(index, focus) {
      this.tabs.forEach((t, i) => {
        const on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      this.panels.forEach((p, i) => { p.hidden = i !== index; });
    }
  });
}
